import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span
                                                    className="heading">AN APPRECIATIVE APPROACH TO FEEDBACK</span>
                                            </div>

                                            <p>When people know what their strengths are and are able to put
                                                them into practice regularly, they are more likely to flourish
                                                than when they focus on marginally improving in those areas
                                                where they need to develop.</p>
                                            <p>Of course, development areas can be major liabilities and do need
                                                to be addressed. People’s strengths, however, are often the
                                                places where it is possible to see the most significant personal
                                                and professional growth.</p>
                                            <p>This appreciative inquiry model of giving feedback is used to
                                                take the strengths of an organisation or individual by
                                                recognising them, and through a process of evaluation, use these
                                                strengths to improve performance.</p>
                                            <div className="border_subtitle">The appreciative inquiry model<a
                                                className="superscripttext"
                                                href="further_info.php?course=300"><sup>3</sup></a></div>
                                            <div className="innovativeimg big_image longimage image_resiz">
                                                <img className=""
                                                     src={require('@images/reimg-cycle.png')}
                                                     alt=""/>
                                            </div>
                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">Discover</div>
                                                <ul className="greenbullet-list">
                                                    <li>Ask the individual to consider what they are like when
                                                        performing at their best.
                                                    </li>
                                                    <li>Give examples of occasions when you have observed
                                                        excellent performance. Be specific about what it was
                                                        that differentiated the individual from an average
                                                        performer.
                                                    </li>
                                                    <li>Explore these incidences and examples and consider how
                                                        they demonstrate the individual’s unique strengths.
                                                    </li>
                                                </ul>
                                            </div>

                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page2')}
                                                     className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}